import { BorrowerStatus } from '../../../../redux/reducers/application/application.types'
import { CouponDto } from '../../coupons/dto/Coupons.dto'

export interface OperatorServiceCenterBorrower {
  id: string
  document: string
  name: string
  phoneNumber: string
}

export interface OperatorServiceCenterBorrowerApplication {
  createdOn: string
  status: BorrowerStatus
  shouldReevaluate?: boolean
}

export interface OperatorServiceCenterBorrowerCredit {
  limit?: number
  availableLimit?: number
  disablePurchase: boolean
  incentiveCategory?: string
  lateDays?: number
}

export enum IncentiveType {
    PERCENTAGE = 'percentage',
    FIXED_VALUE = 'fixed_value',
}

export interface OperatorServiceCenterOperator {
  incentiveValue?: number
  incentiveCap?: number
  incentiveType?: IncentiveType
}

export interface OperatorServiceCenterOptions {
  isContractSimulationAllowed?: boolean
}

export interface OperatorServiceCenterBorrowerResponse {
  borrower: OperatorServiceCenterBorrower
  application: OperatorServiceCenterBorrowerApplication
  credit: OperatorServiceCenterBorrowerCredit
  coupon?: CouponDto
  operator: OperatorServiceCenterOperator
  options?: OperatorServiceCenterOptions
}
export interface OperatorPerformance {
  operatorId?: string
  showIncentive?: boolean
  today?: OperatorResultNumbers
  week?: OperatorResultNumbers
  month?: OperatorResultNumbers
  year?: OperatorResultNumbers
  all?: OperatorResultNumbers
}

export interface OperatorResultNumbers {
  conversions?: number
  applications?: number
  incentive?: number
  startDate?: string
  endDate?: string
}

export interface OperatorPerformanceInfoResponse {
  operatorPerformance?: OperatorPerformance
}
